import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
export const AdminDragdropArea = ({
  children,
  isAdminMode = false,
}: {
  children: React.ReactNode;
  isAdminMode: boolean;
}) => {
  if (!isAdminMode) {
    return <>{children}</>;
  }
  return <DndProvider backend={HTML5Backend}>{children}</DndProvider>;
};
